export const SET_ADMIN_TRENDS_REQUEST = 'SET_ADMIN_TRENDS_REQUEST';
export const SET_ADMIN_TRENDS_SUCCESS = 'SET_ADMIN_TRENDS_SUCCESS';
export const SET_ADMIN_TRENDS_FAILED = 'SET_ADMIN_TRENDS_FAILED';
export const SET_ADMIN_TRENDS_DELETE_FAILED = 'SET_ADMIN_TRENDS_DELETE_FAILED';
export const SET_ADMIN_TRENDS_DELETE_REQUEST = 'SET_ADMIN_TRENDS_DELETE_REQUEST';
export const SET_ADMIN_TRENDS_SCENARIO_SUCCESS = 'SET_ADMIN_TRENDS_SCENARIO_SUCCESS';
export const CLEAN_ADMIN_TRENDS = 'CLEAN_ADMIN_TRENDS';
